<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.59,7.58l-6.24,6.24a0.47,0.47,0,0,1-0.66,0L3.44,7.58a0.47,0.47,0,0,1,0.66-0.66L10,12.82l5.91-5.9a0.47,0.47,0,0,1,0.66,0.66Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconDropDown",
  props: {
    iconName: {
      type: String,
      default: "iconAddMoney",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
